import styled from "styled-components";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

export const GanttPanelWrapper = styled.div`
  height: ${(props) => (props.$isFullScreen ? "100vh" : "calc(100vh - 60px)")};
  background: #f8f7fa;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
`;

export const LeftSectionWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 350px;
  z-index: 99999;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease-in-out;
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;

export const GanttIFframe = styled.iframe`
  border: none;
  z-index: ${(props) => (props.$isFullScreen ? "9999" : 1)};
  position: ${(props) => (props.$isFullScreen ? "absolute" : "static")};
  top: ${(props) => (props.$isFullScreen ? "0" : 1)};
  height: ${(props) => (props.$isFullScreen && "100vh")};
  left: ${(props) => (props.$isFullScreen ? "0" : 1)};
  transition: all 0.3s ease-in-out;
`;

export const LeftSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background-color: white;
  color: black;
  padding: 10px;
  position: absolute;
  bottom: 0;
  z-index: 99999;
`;

export const LeftTitle = styled.div`
  font-weight: 700;
  font-size: 22px;
  color: #111;
  padding: 3px 0px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftCardContainer = styled.div`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1rem;
  overflow-y: auto;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  flex-direction: column;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const LeftStyledCard = styled(Card)`
  margin-bottom: 16px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: #fffcfc;
  min-height: 190px;
`;

export const LeftOrderInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const LeftStyledTypography = styled(Typography)`
  font-family: Gyeonggi_Title_Medium !important;
`;

export const SearchContainer = styled.div`
  padding: 0 0.5rem 0.5rem 0.5rem;
  background-color: white;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
`;

export const SearchActioIconBox = styled.div`
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

export const CloseButton = styled.div`
  cursor: pointer;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
`;
